var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(59.8931 0 0 59.8931 499.4838 499.4823)",
    id: 457396
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(47,47,47)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-10.4974, -9.9998)",
    d: "M 4.22212 3.72456 C 4.4662 3.48048 4.86193 3.48048 5.106 3.72456 L 10.4974 9.11598 L 15.8888 3.72461 C 16.1329 3.48053 16.5286 3.48053 16.7727 3.72461 C 17.0168 3.96869 17.0168 4.36442 16.7727 4.60849 L 11.3813 9.99986 L 16.7726 15.3912 C 17.0167 15.6353 17.0167 16.031 16.7726 16.2751 C 16.5285 16.5191 16.1328 16.5191 15.8887 16.2751 L 10.4974 10.8837 L 5.10605 16.2751 C 4.86198 16.5192 4.46625 16.5192 4.22217 16.2751 C 3.97809 16.031 3.97809 15.6353 4.22217 15.3912 L 9.61354 9.99986 L 4.22212 4.60845 C 3.97804 4.36437 3.97804 3.96864 4.22212 3.72456 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 500 500)",
    id: 139325
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0001 -4.1665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(45,45,45)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-10.4998, -5.8335)",
    d: "M 17.7915 5.8335 C 17.7915 6.17867 17.5117 6.4585 17.1665 6.4585 L 3.83317 6.4585 C 3.48799 6.4585 3.20817 6.17867 3.20817 5.8335 C 3.20817 5.48832 3.48799 5.2085 3.83317 5.2085 L 17.1665 5.2085 C 17.5117 5.2085 17.7915 5.48832 17.7915 5.8335 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(56,56,56)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-10.4998, -10)",
    d: "M 17.7915 10 C 17.7915 10.3452 17.5117 10.625 17.1665 10.625 L 3.83317 10.625 C 3.48799 10.625 3.20817 10.3452 3.20817 10 C 3.20817 9.65482 3.48799 9.375 3.83317 9.375 L 17.1665 9.375 C 17.5117 9.375 17.7915 9.65482 17.7915 10 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.0001 4.1665)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(56,56,56)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-10.4998, -14.1665)",
    d: "M 17.7915 14.1665 C 17.7915 14.5117 17.5117 14.7915 17.1665 14.7915 L 3.83317 14.7915 C 3.48799 14.7915 3.20817 14.5117 3.20817 14.1665 C 3.20817 13.8213 3.48799 13.5415 3.83317 13.5415 L 17.1665 13.5415 C 17.5117 13.5415 17.7915 13.8213 17.7915 14.1665 Z",
    strokeLinecap: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.2b9a4b9570472789593a353410744470.svg";